module.exports = __webpack_public_path__ + "static/img/arrow.7e07f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.png
// module id = OsgU
// module chunks = 1